module.exports = __webpack_public_path__ + "static/right_align-4925682bdc67213cbade1833b432e223.png";